import {Trans} from '@ui/i18n/trans';
import {Button} from '@ui/buttons/button';
import {Link} from 'react-router';
import {HomeIcon} from '@ui/icons/material/Home';
import {MovieIcon} from '@ui/icons/material/Movie';
import {LiveTvIcon} from '@ui/icons/material/LiveTv';
import {SearchIcon} from '@ui/icons/material/Search';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 py-20 text-center">
      <div className="mx-auto max-w-5xl space-y-12">
        <div className="relative">
          <h1 className="text-[140px] font-extrabold tracking-tighter text-primary opacity-10 sm:text-[200px] md:text-[280px] leading-none select-none">
            404
          </h1>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <h2 className="text-3xl font-bold tracking-tight text-main sm:text-5xl lg:text-6xl">
              <Trans message="Oops ! Scène coupée au montage." />
            </h2>
          </div>
        </div>

        <p className="mx-auto max-w-2xl text-lg text-muted sm:text-xl">
          <Trans message="La page que vous recherchez semble introuvable. Elle a peut-être été supprimée, renommée ou n'a jamais existé. Reprenons depuis le début :" />
        </p>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 pt-10">
          <Button
            elementType={Link}
            to="/"
            variant="flat"
            color="primary"
            size="lg"
            startIcon={<HomeIcon />}
            className="w-full shadow-sm transition-transform hover:-translate-y-1"
          >
            <Trans message="Accueil" />
          </Button>

          <Button
            elementType={Link}
            to="/films"
            variant="flat"
            color="primary"
            size="lg"
            startIcon={<MovieIcon />}
            className="w-full shadow-sm transition-transform hover:-translate-y-1"
          >
            <Trans message="Films" />
          </Button>

          <Button
            elementType={Link}
            to="/series"
            variant="flat"
            color="primary"
            size="lg"
            startIcon={<LiveTvIcon />}
            className="w-full shadow-sm transition-transform hover:-translate-y-1"
          >
            <Trans message="Séries" />
          </Button>

          <Button
            elementType={Link}
            to="/search"
            variant="flat"
            color="primary"
            size="lg"
            startIcon={<SearchIcon />}
            className="w-full shadow-sm transition-transform hover:-translate-y-1"
          >
            <Trans message="Recherche" />
          </Button>
        </div>
      </div>
    </div>
  );
}
